const KNOWN_DUMMY_USER_NAMES = ['traveler', 'guest user', 'test user', 'anonymous'];

export function isDummyUserName(name: string): boolean {
  if (!name) {
    return false;
  }
  return KNOWN_DUMMY_USER_NAMES.includes(name.trim().toLowerCase());
}

export class SharedUtilUserName {
  static getFirstName(user: { name?: string; email?: string }): string {
    if (user.name && user.name.trim().length > 0) {
      const names = user.name.trim().split(' ');
      return names[0];
    } else {
      return '';
    }
  }

  static isDummyUserName(name: string): boolean {
    return isDummyUserName(name);
  }

  static guessUserInitialsFromName(name: string): string {
    const names = name.split(' ');
    const initials = names
      .slice(0, 2)
      .map((name) => name.charAt(0).toUpperCase())
      .join('');
    return initials;
  }

  static guessUserInitialsFromEmail(email: string): string {
    const emailParts = email.split('@');
    const emailName = emailParts[0];
    const emailInitials = emailName
      .split('.')
      .map((part) => part.charAt(0).toUpperCase())
      .join('');
    return emailInitials.length > 2 ? emailInitials.slice(0, 2) : emailInitials;
  }

  static guessUserInitialsFromNameOrEmail(user: { name?: string; email?: string }): string {
    const initialsFromName = SharedUtilUserName.guessUserInitialsFromName(user.name || '');
    const initialsFromEmail = SharedUtilUserName.guessUserInitialsFromEmail(user.email || '');
    return initialsFromName.length > 0 ? initialsFromName : initialsFromEmail;
  }
}
